import React, { FC, useMemo } from 'react';
import { observer } from 'mobx-react-lite';

import { Transition } from 'react-transition-group';
import { ModalContainerWrapperStyled } from './ModalContainerStyled';
import { useStore } from '@hooks';

const ModalContainer: FC<{}> = (): JSX.Element => {
    const { modalService } = useStore();

    const { template, visible } = modalService;

    const ModalComponent = useMemo<JSX.Element>(() => {
        const Component = template;

        return <Component />;
    }, [template]);

    return (
        <Transition in={visible} timeout={100}>
            {(state): JSX.Element => (
                <ModalContainerWrapperStyled visible={visible} className={`${state} modal-wrapper`}>
                    <div>{ModalComponent}</div>
                </ModalContainerWrapperStyled>
            )}
        </Transition>
    );
};

export default observer(ModalContainer);
